import { useSearchParams } from "react-router-dom";

export type MapEmbedParams = {
  isEmbedded: boolean;
  /** Null when omitted; an empty string remains an invalid supplied value. */
  stationSlug: string | null;
};

export function useMapEmbedParams(): MapEmbedParams {
  const [searchParams] = useSearchParams();
  const isEmbedded = searchParams.get("embed") === "true";
  const stationSlug = searchParams.get("station")?.trim() ?? null;

  return {
    isEmbedded,
    stationSlug,
  };
}
